import React from 'react';
import { Link } from 'react-router-dom';
import _get from 'lodash/get';
import styles from './index.module.scss';

import { ReactComponent as LinkIcon } from 'assets/img/icons/external-link.svg';
import { UiKit } from 'components';
import { If } from 'utils';

/**
 * @param {Object} props
 * @param {import("utils/types").FeatureCardLink} props.link
 * @param {boolean} props.disabled
 * @param {boolean} props.hasAccess
 */
export default function FeatureLink({
  link,
  disabled = false,
  hasAccess = true
}) {
  if (!link) return null;

  const url = _get(link, 'url', '');
  const btnText = _get(link, 'title', '');
  const isLoading = _get(link, 'isLoading', false);
  const isDisabled = _get(link, 'isDisabled', false);
  const isExternal = _get(link, 'external', false);
  const showIcon = _get(link, 'showIcon', false);
  const icon = _get(link, 'icon', <LinkIcon className={styles.icon} />);

  const button = (
    <UiKit.Button
      variant="outline"
      disabled={disabled || isDisabled}
      processing={isLoading}
      processingText="Loading"
    >
      {!hasAccess ? 'View Details' : btnText} {showIcon && icon}
    </UiKit.Button>
  );

  return (
    <div className={styles.container}>
      <If test={isExternal}>
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          data-disabled={disabled || isDisabled}
        >
          {button}
        </a>
      </If>
      <If test={!isExternal}>
        <Link to={url} data-disabled={disabled || isDisabled}>
          {button}
        </Link>
      </If>
    </div>
  );
}
